export class EnrollmentLinkAttribute <T> {
    // value?: T;
    value: T | undefined;        
    key: string;
    label: string;
    options: {label: string, value: string}[];
  
    constructor(options: {
        value?: T;
        key?: string;
        label?: string;
        options?: {label: string, value: string}[];
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label === undefined ? '' : options.label + ':';
      this.options = options.options || [];
    }
}
